<template>
  <router-link tag="article" :to="link">
    <div class="sys-card">
      <div>
        <h2 class="sys-card-title">
          {{ title }}
        </h2>

        <span class="sys-card-link" v-if="hasButton">Saiba Mais</span>
      </div>
    </div>
    <!-- /.sys-card -->
  </router-link>
</template>

<script>
  export default {
    name: 'Cards',
    props: {
      title: String,
      link: String,
      hasButton: Boolean
    }
  };
</script>

<style scoped lang="scss">
  .sys-card {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 175px;

    padding: 20px 40px;

    &:hover {
      .sys-card-link {
        color: #ffffff;

        background-color: #7a2722;
      }
    }
  }

  .sys-card-title {
    font-size: 24px;
  }

  .sys-card-link {
    display: inline-block;
    padding: 10px 30px;
    margin-top: 10px;

    font-family: 'Lato', sans-serif;

    border: 2px solid #7a2722;
    border-radius: 50px;

    transition: background-color .2s ease-in-out;
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    .sys-card-link {
      font-size: 12px;
    }
  }
</style>
